import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vShow as _vShow, normalizeStyle as _normalizeStyle, withDirectives as _withDirectives } from "vue"
import _imports_0 from '../assets/loading.gif'


const _hoisted_1 = { class: "favorite" }
const _hoisted_2 = { class: "favorite-contents" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "image-area" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "project-title" }
const _hoisted_7 = {
  key: 0,
  class: "no-data"
}
const _hoisted_8 = ["src"]

import { useRouter } from "vue-router";
import { onMounted, ref } from "vue";
import { ProjectStore } from "../store/ProjectStore";
import { CommonStore } from "../store/CommonStore";
import { NO_DATA } from "../consts/common";


export default /*@__PURE__*/_defineComponent({
  __name: 'Favorite',
  setup(__props) {

const projectStore = ProjectStore();

const loading = ref(true);
const commonStore = CommonStore();
const displayList = ref(projectStore.favoriteProjectList || []);

onMounted(async () => {
  if (!projectStore.favoriteProjectList.length) {
    await getProjectList();
  } else if (
    projectStore.favoriteProjectList.length &&
    !projectStore.favoriteAllCalled
  ) {
    projectStore.forceUpdateFavorite();
    loading.value = false;
  } else {
    displayList.value = projectStore.favoriteProjectList || [];
    getScrollHeight();
    loading.value = false;
  }
});
// スクロール位置の保持、無限スクロール
const handleScroll = async () => {
  const container = document.getElementsByClassName(
    "favorite-contents-item-selection"
  )[0] as HTMLElement;
  if (projectStore.favoriteAllCalled) return;

  setScrollHeight();
  if (loading.value) return;
  if (!container || !container.scrollHeight) return
  if (
    container.scrollHeight - (container.clientHeight + container.scrollTop) >
    120
  )
    return;

  loading.value = true;
  const initLoading = document.getElementsByClassName(
    "loading"
  )[0] as HTMLElement;
  initLoading.style.top =
    container.offsetTop + container.scrollHeight - 50 + "px";

  const pageNum = projectStore.favoritePageNum + 1;
  projectStore.setFavoritePageNum(pageNum);
  await projectStore.getFavoriteProjects();
  displayList.value = projectStore.favoriteProjectList || [];
  loading.value = false;
};
const setScrollHeight = () => {
  const item = document.getElementsByClassName(
    "favorite-contents-item-selection"
  )[0] as HTMLElement;
  if(!item || !item.scrollTop) return
  commonStore.setFavoriteScrollHeight(item.scrollTop);
};
const getScrollHeight = () => {
  displayList.value = projectStore.favoriteProjectList || [];
  const item = document.getElementsByClassName(
    "favorite-contents-item-selection"
  )[0] as HTMLElement;
  if (!item) return;
  item.scrollTo({
    top: commonStore.getFavoriteScrollHeight,
    behavior: "auto",
  });
};

const hiddenLoading = () => {
  if (!loading.value) {
    return "visibility: hidden;";
  } else {
    return "visibility: visible;";
  }
};

const getProjectList = async () => {
  loading.value = true;
  await projectStore.getFavoriteProjects().then(() => {
    displayList.value = projectStore.favoriteProjectList || [];
    loading.value = false;
  });
};

const router = useRouter();
document.title = "お気に入り";

// const store = ProjectStore();

const detail = (id: number) => {
  projectStore.setSelectedId(id);
  router.push("/project-detail");
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass([_unref(commonStore).getupDatingToast.showToast ? 'l-modal__bg' : ''])
    }, null, 2 /* CLASS */),
    _createCommentVNode(" お気に入り案件 "),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("section", {
          class: "favorite-contents-item-selection",
          onScroll: _cache[0] || (_cache[0] = ($event: any) => (handleScroll()))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayList.value, (data, index) => {
            return (_openBlock(), _createElementBlock("div", { key: index }, [
              _createElementVNode("ul", {
                class: "product-img-wrap",
                onClick: ($event: any) => (detail(data.id))
              }, [
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("img", {
                    src: data.image
                  }, null, 8 /* PROPS */, _hoisted_5),
                  _createElementVNode("div", null, [
                    _createElementVNode("p", _hoisted_6, _toDisplayString(data.title), 1 /* TEXT */)
                  ])
                ])
              ], 8 /* PROPS */, _hoisted_3)
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _withDirectives(_createElementVNode("div", {
            style: _normalizeStyle(hiddenLoading()),
            class: _normalizeClass([
            displayList.value && displayList.value.length > 0 ? 'loading' : 'first-loading',
          ])
          }, _cache[1] || (_cache[1] = [
            _createElementVNode("img", { src: _imports_0 }, null, -1 /* HOISTED */)
          ]), 6 /* CLASS, STYLE */), [
            [_vShow, loading.value]
          ])
        ], 32 /* NEED_HYDRATION */),
        _createCommentVNode(" </transition> ")
      ]),
      (!loading.value && !displayList.value?.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
            _createElementVNode("img", {
              src: _unref(NO_DATA).get(4).img
            }, null, 8 /* PROPS */, _hoisted_8)
          ]))
        : _createCommentVNode("v-if", true)
    ])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})